import httpClient from '../httpClient';


const getPhoto =  () => httpClient.get('/MainPage/Photo/Get').then(
  (data) => data
)
  .catch(()=>{
   //
  })
const setPhoto =  (params) => httpClient.post('/MainPage/Photo/Post', {

  webImgPath: params.webImgPath,
  mobileImgPath: params.mobileImgPath
},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
const putPhoto = (params,id) => httpClient.put(`/MainPage/Photo/PUT/${id}`, {
  id:id,
  webImgPath: params.webImgPath,
  mobileImgPath: params.mobileImgPath
},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })


const  deletePhoto= (id) => httpClient.delete(`/MainPage/Photo/Delete/${id}`,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

export {
  getPhoto,
  setPhoto,
  putPhoto,
  deletePhoto
  // getUser,
  // createUser
}
